var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, EmptyState, EmptyStateBody, EmptyStateFooter, EmptyStateVariant } from '@patternfly/react-core';
import NotFoundIcon from '../NotFoundIcon';
export const MissingPage = (_a) => {
    var { toHomePageUrl = window.location.origin, toHomePageText = 'Return to homepage', titleText = 'We lost that page', bodyText = "Let's find you a new one. Try a new search or return home.", ouiaId = "MissingPage", headingLevel = 'h1' } = _a, props = __rest(_a, ["toHomePageUrl", "toHomePageText", "titleText", "bodyText", "ouiaId", "headingLevel"]);
    return (_jsxs(EmptyState, Object.assign({ headingLevel: headingLevel, icon: NotFoundIcon, variant: EmptyStateVariant.full, "data-ouia-component-id": ouiaId }, props, { titleText: titleText, children: [_jsx(EmptyStateBody, { "data-ouia-component-id": `${ouiaId}-body`, children: bodyText }), _jsx(EmptyStateFooter, { "data-ouia-component-id": `${ouiaId}-footer`, children: _jsx(Button, { variant: "link", component: "a", href: toHomePageUrl, ouiaId: `${ouiaId}-home-button`, children: toHomePageText }) })] })));
};
export default MissingPage;
